"use client";

import React, { MouseEvent } from "react";
export default function LocationsFinalSection() {
  const handleScrollToContact = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const target = document.getElementById("contact-form");
    target?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  };
  return <section className="relative overflow-hidden bg-[#0f172a] px-6 py-24 text-white md:px-12 md:py-28">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(255,255,255,0.06),transparent_34%)]" />
        <div className="absolute left-0 top-0 h-80 w-80 rounded-full bg-white/[0.03] blur-3xl" />
        <div className="absolute bottom-0 right-0 h-80 w-80 rounded-full bg-[#166534]/[0.08] blur-3xl" />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl">
        <div className="mb-14 max-w-4xl">
          <div className="mb-5 inline-flex items-center rounded-full border border-white/10 bg-white/[0.06] px-4 py-2 text-[11px] font-medium uppercase tracking-[0.22em] text-white/72 backdrop-blur-md sm:text-xs">
            Почему две локации — это важно
          </div>

          <h2 className="mb-6 font-default text-3xl font-bold tracking-[-0.03em] text-white sm:text-4xl md:text-5xl">
            Две локации —
            <span className="text-[#166534]"> одна система развития</span>
          </h2>

          <div className="space-y-4 font-default text-lg leading-relaxed text-white/78">
            <p>
              Основной центр и ферма не конкурируют друг с другом, а решают
              разные задачи внутри одной общей системы.
            </p>
            <p>
              В городе ребёнок получает структуру, регулярность, ежедневную
              практику и формирование базовых навыков. На ферме он получает
              природную среду, сенсорный опыт, эмоциональную устойчивость и
              более живое взаимодействие с миром.
            </p>
            <p>
              Вместе эти две локации делают программу глубже, сильнее и
              естественнее для ребёнка.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-8 xl:grid-cols-3">
          <div className="rounded-[36px] border border-white/12 bg-white/[0.08] p-8 shadow-[0_16px_46px_rgba(0,0,0,0.18)] backdrop-blur-xl md:p-10">
            <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-white/[0.08]">
              <span className="text-xl text-[#d8c27a]">01</span>
            </div>

            <h3 className="mb-4 font-default text-2xl font-semibold tracking-[-0.03em] text-white">
              Основной центр
            </h3>

            <p className="font-default text-base leading-7 text-white/78">
              Даёт системные занятия, структуру дня, оборудованную среду и
              последовательную ежедневную работу над навыками.
            </p>
          </div>

          <div className="rounded-[36px] border border-white/12 bg-white/[0.08] p-8 shadow-[0_16px_46px_rgba(0,0,0,0.18)] backdrop-blur-xl md:p-10">
            <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-white/[0.08]">
              <span className="text-xl text-[#d8c27a]">02</span>
            </div>

            <h3 className="mb-4 font-default text-2xl font-semibold tracking-[-0.03em] text-white">
              Ферма
            </h3>

            <p className="font-default text-base leading-7 text-white/78">
              Даёт природную среду, контакт с животными, сенсорный опыт,
              эмоциональную устойчивость и более свободное взаимодействие с
              пространством.
            </p>
          </div>

          <div className="rounded-[36px] border border-[#d9d1b7]/20 bg-[#d9d1b7]/10 p-8 shadow-[0_16px_46px_rgba(0,0,0,0.18)] backdrop-blur-xl md:p-10">
            <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#d9d1b7]/12">
              <span className="text-xl text-[#d8c27a]">03</span>
            </div>

            <h3 className="mb-4 font-default text-2xl font-semibold tracking-[-0.03em] text-white">
              Вместе
            </h3>

            <p className="font-default text-base leading-7 text-white/78">
              Вместе две локации создают более полную среду, где ребёнок
              развивает не только навыки, но и устойчивость, уверенность и
              способность адаптироваться к разным условиям.
            </p>
          </div>
        </div>

        <div id="contact-form" className="mt-12 rounded-[40px] border border-white/12 bg-white/[0.08] p-8 shadow-[0_24px_60px_rgba(0,0,0,0.24)] backdrop-blur-xl md:p-10">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_auto] lg:items-end">
            <div className="max-w-3xl">
              <div className="mb-5 inline-flex items-center rounded-full border border-white/10 bg-white/[0.06] px-4 py-2 text-[11px] font-medium uppercase tracking-[0.22em] text-white/72 backdrop-blur-md sm:text-xs">
                Финальный шаг
              </div>

              <h3 className="mb-5 font-default text-3xl font-bold tracking-[-0.03em] text-white sm:text-4xl md:text-5xl">
                Подберём подходящий
                <br />
                <span className="text-[#166534]">формат занятий</span>
              </h3>

              <p className="font-default text-lg leading-relaxed text-white/78">
                Мы поможем определить, какая локация, нагрузка и среда будут
                полезны именно вашему ребёнку.
              </p>
            </div>

            <div className="flex flex-col gap-4 sm:flex-row lg:flex-col">
              <a href="#contact-form" onClick={handleScrollToContact} className="group relative inline-flex h-14 items-center justify-center overflow-hidden rounded-full border border-white/10 bg-white px-10 text-base font-semibold text-slate-900 shadow-[0_12px_32px_rgba(15,23,42,0.22)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_18px_42px_rgba(15,23,42,0.28)]">
                <span className="relative z-10">Записаться на диагностику</span>
              </a>

              <a href="tel:+905465166807" className="group relative inline-flex h-14 items-center justify-center overflow-hidden rounded-full border border-white/16 bg-white/10 px-8 text-base font-semibold text-white shadow-[0_12px_28px_rgba(15,23,42,0.14)] backdrop-blur-sm transition-all duration-300 hover:-translate-y-0.5 hover:border-white/28 hover:bg-white/14 hover:shadow-[0_18px_40px_rgba(15,23,42,0.22)]">
                <span className="relative z-10">Связаться с администратором</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}